<template>
  <el-menu theme="dark" mode="horizontal" router>
    <el-menu-item index="/">Home</el-menu-item>
    <el-menu-item index="/items">Items</el-menu-item>
    <el-submenu index="user" class="profile">
      <template slot="title">{{email}}</template>
      <el-menu-item index="/profile">Profile</el-menu-item>
      <div class="line"></div>
      <el-menu-item index="signout">
        <div v-on:click.stop="signOut">Sign out</div>
      </el-menu-item>
    </el-submenu>
  </el-menu>
</template>

<script>
import { auth } from 'firebase'

export default {
  name: 'MainNav',
  props: ['email'],
  methods: {
    signOut() {
      auth().signOut()
    }
  },
}
</script>

<style lang="stylus" scoped>
.profile
  float right !important

.line
  height 1px
  background-color #e0e6ed
  margin 5px 0px 5px 0px

</style>



// WEBPACK FOOTER //
// MainNav.vue?e07b1daa